var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLockWhite = function SvgLockWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "current",
    height: "current",
    viewBox: "0 0 92 112"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lock-white_svg__c",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bbc1e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lock-white_svg__d",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#756bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4861ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.178 6.205)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#lock-white_svg__\\uC0AC\\uAC01\\uD615_555)",
    transform: "translate(-9.18 -6.21)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 7,
    "data-name": "\\uC0AC\\uAC01\\uD615 555",
    transform: "translate(19 6)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 78,
    stroke: "none",
    rx: 27
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 71,
    x: 3.5,
    y: 3.5,
    rx: 23.5
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#lock-white_svg__\\uC0AC\\uAC01\\uD615_553)",
    transform: "translate(-9.18 -6.21)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#lock-white_svg__c)",
    d: "M13 0h48a13 13 0 0 1 13 13v24a23 23 0 0 1-23 23H23A23 23 0 0 1 0 37V13A13 13 0 0 1 13 0",
    "data-name": "\\uC0AC\\uAC01\\uD615 553",
    transform: "translate(9 40)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 27,
    fill: "url(#lock-white_svg__d)",
    "data-name": "\\uC0AC\\uAC01\\uD615 554",
    rx: 3.5,
    transform: "translate(33.822 45.795)"
  }))));
};
export default SvgLockWhite;